import { BlogPost } from "../type";

export function getBlogLink(post: BlogPost) {
  const { id, title } = post;
  return `/blog/${id}/${title}`;
}
